import React, { useState } from "react";
import { Form, Card, Button } from "react-bootstrap";
import validator from "validator";
import Bar from '../Bar';


// creating functional component ans getting props from app.js and destucturing them
const StepTwo = ({ nextStep, handleFormData, prevStep, values }) => {
  
   //creating error state for validation
  const [error, setError] = useState(false);

    // after form submit validating the form data using validator
  const submitFormData = (e) => {
    e.preventDefault();

     // checking if value of first name and last name is empty show error else take to next step
    if (validator.isEmpty(values.investmentValue) || validator.isEmpty(values.restaurantsValue) || validator.isEmpty(values.restaurantsValueLabel)) {
      setError(true);
    } else {
      nextStep();
    }
  };
  return (
    <>
    <Bar/>

      <Card style={{ marginTop: 100 }}>
        <Card.Body>
          <Form onSubmit={submitFormData}>
            <Form.Group className="mb-3">
              <Form.Label>Investment Value<optional>*</optional></Form.Label>
              <Form.Control
                style={{ border: error ? "2px solid red" : "" }}
                type="number"
                placeholder="SYP"
                onChange={handleFormData("investmentValue")}
              />
              
              {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}
            </Form.Group>

            <Form.Group className="mb-3">
            <Form.Label>Target Label<optional>*</optional></Form.Label>
            <select className="form-control" defaultValue={values.restaurantsValueLabel} style={{ border: error ? "2px solid red" : "" }} onChange={handleFormData("restaurantsValueLabel")}>
            {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}

              <option hidden>Open to Select</option>
                <option value=' 42.4%' >Foods</option>
                <option value=' 56.3%' >Drinks</option>
                <option value=' 37.4%'>Sweets</option>
            </select>
            </Form.Group>

            <Form.Group className="mb-3">
            <Form.Label>Target Sectors<optional>*</optional></Form.Label>
            <select className="form-control" defaultValue={values.restaurantsValue} style={{ border: error ? "2px solid red" : "" }} onChange={handleFormData("restaurantsValue")}>
            {error ? (
                <Form.Text style={{ color: "red" }}>
                  This is a required field
                </Form.Text>
              ) : (
                ""
              )}

              <option hidden>Open to Select</option>
              <optgroup label="Foods">
                <option value=' 
                1- Abu al Abd, The Dimension is (230 M)
                2- Al Kamal, The Dimension is (200 M)
                3- Al jnani, The Dimension is (120 M)
                ' >Fast Food</option>
              </optgroup>
              <optgroup label="Drinks">
                <option value={ <p>The Result of The Chosen location:</p> }>Pubs and Bars</option>
                <option value=' 
                1- Café sabaa bahrat, The Dimension is (450 M)
                2- Alarab Cafe, The Dimension is (500 M)
                3- Rock Star , The Dimension is (430 M)
                ' >Café</option>
              </optgroup>
              <optgroup label="Sweets">
                <option value=' 
                1- Al Wissam Confectionary, The Dimension is 10 KM
                2- Murad Sweets, The Dimension is 10 KM
                3- Sllorh Sweets, The Dimension is 10 KM
                ' >Arabic Sweets</option>
                <option value=' 
                1- Omaya Class Dairy, The Dimension is (1 M)
                2- Bee patisserie, The Dimension is (150 M)
                3- Tello, The Dimension is (100 M)
                ' >Italian Sweets</option>
              </optgroup>
            </select>
            </Form.Group>


            <Form.Group className="mb-3">
            <Form.Label>Investment Location<optional>*</optional></Form.Label>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d831.6042908716842!2d36.29495982920956!3d33.51653799879717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1518e7af2275f203%3A0xe81cc04e3b7ff97b!2z2KPZhdmK2Kkg2YPZhNin2LMg2K_Yp9mK2LHZig!5e0!3m2!1sen!2s!4v1659896621694!5m2!1sen!2s"
              width={600}
              height={450}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"/>
              </Form.Group>
              
            <div style={{ display: "flex", justifyContent: "space-around"  ,marginTop: 25 }}>
              <Button variant="primary" onClick={prevStep}>
                Previous
              </Button>

              <Button variant="primary" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default StepTwo;
